import { alpha } from '@mui/material/styles';
import { blue02, blue20, blue20opacity15 } from '../../../colors/blue';
import { gray40opacity10 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var listStylesDark = {
    focusVisible: {
        backgroundColor: 'transparent',
        outline: "solid ".concat(rem(1), " ").concat(blue02),
    },
    hover: {
        backgroundColor: gray40opacity10,
    },
    focused: {
        outline: "solid ".concat(rem(1), " ").concat(blue02),
        outlineColor: blue02,
    },
    selected: {
        backgroundColor: blue20opacity15,
    },
    // Combinations of states
    focusHover: {
        backgroundColor: gray40opacity10,
    },
    selectedHover: {
        backgroundColor: alpha(blue20, 0.125),
    },
};
export var MuiListItem = {
    styleOverrides: {
        root: {
            // Focus, hover and selected states
            '&[class*=Mui-focusVisible], &:focus-visible[tabindex]': {
                outline: listStylesDark.focusVisible.outline,
                backgroundColor: listStylesDark.focusVisible.backgroundColor, // should be transparent by default and changed only if other states are present
            },
            '&.MuiListItem-button:hover, &[class*=Mui-focusVisible]:hover': {
                backgroundColor: listStylesDark.hover.backgroundColor,
            },
            "&[class*='Mui-selected'], &[class*='Mui-selected'].Mui-focusVisible, &[class*='Mui-selected']:focus-visible[tabindex]": {
                backgroundColor: listStylesDark.selected.backgroundColor,
            },
            "&[class*='Mui-selected']:hover": {
                backgroundColor: listStylesDark.selectedHover.backgroundColor,
            },
        },
    },
    customOverrides: {
        comfortable: {
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 ".concat(rem(1), " ").concat(blue02),
            },
        },
    },
};
